const publicPath = process.env.BASE_URL;

import braket from "file-loader!mathjax/es5/input/tex/extensions/braket.js";
import physics from "file-loader!mathjax/es5/input/tex/extensions/physics.js";

export default new Promise((resolve) => {
  window.MathJax = {
    chtml: {
      fontURL: publicPath + "fonts/",
    },
    tex: {
      packages: { "[+]": ["physics"], "[-]": [] },
      macros: {
        span: "\\mathop{\\rm span}\\nolimits",
        meas: "\\mathop{\\rm meas}\\nolimits",
        xmin: "x_\\text{min}",
        xmax: "x_\\text{max}",
        ymin: "y_\\text{min}",
        ymax: "y_\\text{max}",
      },
    },
    loader: {
      source: {
        "[tex]/braket": braket,
        "[tex]/physics": physics,
      },
      load: ["[tex]/physics"],
    },
    startup: {
      ready: () => {
        const MathJax = window.MathJax;
        MathJax.startup.defaultReady();
        document.head.appendChild(MathJax.chtmlStylesheet());
        resolve(MathJax);
      },
    },
  };

  import("mathjax/es5/tex-chtml.js");
});
